/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-string-refs */
/* eslint-disable no-restricted-globals */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/no-unused-state */
/* eslint-disable jsx-a11y/label-has-associated-control */

// @mui material components
import Card from "@mui/material/Card";
// import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import "react-dropdown/style.css";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import {
  Table,
  TableCell,
  TableHead,
  TableBody,
  TableRow,
  IconButton,
  Button,
  InputAdornment,
} from "@mui/material";
// import { AccessAlarm, ThreeDRotation } from "@mui/icons-material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

// Soft UI Dashboard React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import { useTranslation } from "react-i18next";
import AlertDialog from "./dialog_success";
import DeleteUser from "./delete_user";

function AddUser() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [name, setName] = useState();
  const [password, setPassword] = useState();
  const [email, setEmail] = useState();
  const [mobile, setMobile] = useState();
  const [role_id, setRoleID] = useState();
  return (
    <DashboardLayout>
      <SuiBox py={3}>
        <SuiBox mb={3}>
          <Card>
            <SuiBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
              <SuiTypography variant="h6">New Account</SuiTypography>
            </SuiBox>
            <div style={{ width: "400px", margin: "20px" }}>
              <div className="form-group  col-md-12 ">
                <label className="control-label" htmlFor="name" style={{ fontSize: "15px" }}>
                  Name
                </label>
                <input
                  required
                  id="name"
                  type="text"
                  onChange={(e) => setName(e.target.value)}
                  className="form-control"
                  name="name"
                  placeholder="Name"
                  value={name}
                />
              </div>
              <div className="form-group  col-md-12 ">
                <label className="control-label" htmlFor="name" style={{ fontSize: "15px" }}>
                  Password
                </label>
                <input
                  required
                  id="name"
                  type="text"
                  onChange={(e) => setPassword(e.target.value)}
                  className="form-control"
                  name="name"
                  placeholder="password"
                  value={password}
                />
              </div>
              <div className="form-group  col-md-12 ">
                <label className="control-label" htmlFor="name" style={{ fontSize: "15px" }}>
                  Email
                </label>
                <input
                  required
                  id="name"
                  type="text"
                  onChange={(e) => setEmail(e.target.value)}
                  className="form-control"
                  name="name"
                  placeholder="Email"
                  value={email}
                />
              </div>
              <div className="form-group  col-md-12 ">
                <label className="control-label" htmlFor="name" style={{ fontSize: "15px" }}>
                  Mobile
                </label>
                <input
                  required
                  id="name"
                  type="text"
                  onChange={(e) => setMobile(e.target.value)}
                  className="form-control"
                  name="name"
                  placeholder="Mobile Number"
                  value={mobile}
                />
              </div>

              <div className="form-group  col-md-12 ">
                <label
                  className="control-label"
                  htmlFor="name"
                  style={{ fontSize: "15px", marginTop: "20px" }}
                >
                  Role ID
                </label>
                <select
                  id="value_type"
                  className="form-control"
                  value={role_id}
                  onChange={(e) => setRoleID(e.target.value)}
                >
                  <option value="admin">Admin </option>
                  <option value="employee">Employee</option>
                  <option value="customer">Customer</option>
                </select>
              </div>

              <AlertDialog
                name1={name}
                email1={email}
                mobile1={mobile}
                role_id1={role_id}
                password1={password}
              />
            </div>
          </Card>
        </SuiBox>
      </SuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AddUser;
